export function hasLocalStorage(): boolean {
  try {
    return typeof window !== 'undefined' && !!window.localStorage
  } catch {
    return false
  }
}

export function lsGet(key: string): string | null {
  if (!hasLocalStorage()) return null
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function lsSet(key: string, value: string): void {
  if (!hasLocalStorage()) return
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // ignore
  }
}

export function lsRemove(key: string): void {
  if (!hasLocalStorage()) return
  try {
    window.localStorage.removeItem(key)
  } catch {
    // ignore
  }
}
